(function () {
  // external defer script lives outside .okt; the page renders one section, so query it directly.
  var root = document.querySelector('.okt');
  if (!root || root.dataset.oktInit) return;
  root.dataset.oktInit = '1';

  var ENDPOINT = (root.dataset.endpoint || '').trim();
  var ANON = (root.dataset.anonKey || '').trim();
  var lastArgs = null; // last successful lookup args — lets "Check for updates" re-run it
  var SUPPORT_EMAIL = (root.dataset.supportEmail || 'support@okuracookware.com').trim();
  var CARE_URL = (root.dataset.careUrl || '').trim();

  // ── i18n bridge (language-neutral plumbing) ──
  // Copy comes from window.OKT_I18N (injected by the Liquid section, English this phase); t() falls
  // back to the same hardcoded English, so the page is byte-identical whether the dict is present or
  // not. tf() does {token} substitution. NL phase populates OKT_I18N from Shopify locale files —
  // no JS change. Fallbacks stay verbatim so a missing/partial dict never changes the page.
  var I18N = (window.OKT_I18N && typeof window.OKT_I18N === 'object') ? window.OKT_I18N : {};
  function t(key, fallback) { var v = I18N[key]; return (typeof v === 'string') ? v : fallback; }
  function tf(key, fallback, subs) {
    var s = t(key, fallback);
    if (subs) for (var k in subs) s = s.split('{' + k + '}').join(subs[k]);
    return s;
  }

  // English display labels keyed by sanitize() stage.
  var LABELS = {
    order_placed: t('label_order_placed', 'Order placed'),
    shipment_prepared: t('label_shipment_prepared', 'Shipment prepared'),
    in_transit: t('label_in_transit', 'In transit'),
    arrived_destination_country: t('label_arrived_destination_country', 'Arrived in your country'),
    out_for_delivery: t('label_out_for_delivery', 'Out for delivery'),
    delivered: t('label_delivered', 'Delivered'),
    exception: t('label_exception', 'Delay')
  };
  var ORDER = ['order_placed','shipment_prepared','in_transit','arrived_destination_country','out_for_delivery','delivered'];

  function view(name, opts) {
    root.querySelectorAll('[data-okt-view]').forEach(function (el) { el.hidden = el.getAttribute('data-okt-view') !== name; });
    // announce the view change to screen readers by moving focus to its heading —
    // except on silent in-place refreshes, which must not move focus or scroll.
    if (!(opts && opts.noFocus) && (name === 'form' || name === 'result' || name === 'empty')) {
      var h = root.querySelector('[data-okt-view="' + name + '"] .okt-status');
      if (h) h.focus();
    }
  }
  function el(sel) { return root.querySelector('[data-okt="' + sel + '"]'); }
  function fmtDate(iso) {
    if (!iso) return null;
    var d = new Date(iso); if (isNaN(d)) return null;
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }
  // "Jul 1, 4:20 PM" — local browser timezone, for events that carry a meaningful clock time.
  function fmtDateTime(iso) {
    if (!iso) return '';
    var d = new Date(iso); if (isNaN(d)) return '';
    return d.toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
  }

  // estimatedDelivery may be an ISO date OR a window string ("Jun 30, 2026 - Jul 04, 2026").
  function etaValue(v) { return fmtDate(v) || (v ? String(v) : null); }
  function etaSentence(currentStage, v, isPackage) {
    if (currentStage === 'delivered') return isPackage ? t('eta_delivered_package', 'This package has been delivered.') : t('eta_delivered_order', 'Your order has been delivered.');
    return v ? tf('eta_estimated', 'Estimated delivery — {v}.', { v: v }) : t('eta_keep_posted', 'We’ll keep you posted as it moves.');
  }

  // "3 hours ago" — recency of the newest carrier scan.
  function relTime(iso) {
    var d = new Date(iso); if (isNaN(d)) return null;
    var m = Math.round((Date.now() - d.getTime()) / 60000);
    if (m < 1) return t('rel_just_now', 'just now');
    if (m < 60) return m + (m === 1 ? t('rel_minute', ' minute ago') : t('rel_minutes', ' minutes ago'));
    var h = Math.round(m / 60);
    if (h < 48) return h + (h === 1 ? t('rel_hour', ' hour ago') : t('rel_hours', ' hours ago'));
    return Math.round(h / 24) + t('rel_days', ' days ago');
  }

  // "Arriving in 3–5 days" — client-side countdown from the machine-readable etaRange.
  function countdownText(r, current, ofdStale) {
    if (!r || !r.from || !r.to || current === 'delivered') return null;
    var parse = function (s) { var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(s)); return m ? new Date(+m[1], +m[2] - 1, +m[3]) : null; };
    var from = parse(r.from), to = parse(r.to);
    if (!from || !to) return null;
    var now = new Date();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var DAY = 86400000;
    var df = Math.round((from - today) / DAY), dt = Math.round((to - today) / DAY); // round, not ceil: a 25h DST day must not add a phantom day
    var fmtTo = function () { return to.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
    // decision table (df = days to window start, dt = days to window end):
    //   dt < 0                  -> null               window fully passed, say nothing
    //   OFD && !ofdStale        -> "Arriving today"   physically on the truck now
    //   dt === 0                -> "Arriving today"   window ends today
    //   df <= 0 (started, dt>0) -> "Arriving by <to>" started but not over — never a false "today"
    //   df === 1 && dt === 1    -> "Arriving tomorrow" single-day window tomorrow
    //   df === dt (future)      -> "Arriving in N days"
    //   else                    -> "Arriving in X–Y days"
    if (dt < 0) return null;
    if (current === 'out_for_delivery' && !ofdStale) return t('cd_today', 'Arriving today');
    if (dt === 0) return t('cd_today', 'Arriving today');
    if (df <= 0) return tf('cd_by', 'Arriving by {date}', { date: fmtTo() });
    if (df === 1 && dt === 1) return t('cd_tomorrow', 'Arriving tomorrow');
    return df === dt ? tf('cd_in_days', 'Arriving in {n} days', { n: df }) : tf('cd_in_range', 'Arriving in {from}–{to} days', { from: df, to: dt });
  }

  // Pickup collected? explicit backend flag wins; older responses fall back to the delivered stage.
  function collectedOf(info, stage) {
    return info.collected === true || (info.collected === undefined && stage === 'delivered');
  }

  // RFC5545 text escaping: backslash, semicolon, comma, newlines.
  function icsEscape(s) {
    return String(s).replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\r?\n/g, '\\n');
  }
  // All-day VEVENT for the delivery window (DTEND exclusive -> to + 1 day). CRLF line endings.
  function buildIcs(orderNo, fromYmd, toYmd, pageUrl) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(toYmd);
    var end = new Date(+m[1], +m[2] - 1, +m[3] + 1);
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var endYmd = '' + end.getFullYear() + pad(end.getMonth() + 1) + pad(end.getDate());
    var n = new Date();
    var stamp = n.getUTCFullYear() + pad(n.getUTCMonth() + 1) + pad(n.getUTCDate()) +
      'T' + pad(n.getUTCHours()) + pad(n.getUTCMinutes()) + pad(n.getUTCSeconds()) + 'Z';
    return ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Okura Cookware//Tracking//EN', 'BEGIN:VEVENT',
      'UID:' + icsEscape(orderNo) + '@okuracookware.com',
      'DTSTAMP:' + stamp,
      'DTSTART;VALUE=DATE:' + fromYmd.replace(/-/g, ''),
      'DTEND;VALUE=DATE:' + endYmd,
      'SUMMARY:' + icsEscape(tf('ics_summary', 'Okura Cookware delivery — order {order}', { order: orderNo })),
      'DESCRIPTION:' + icsEscape('Track your delivery: ' + pageUrl),
      'END:VEVENT', 'END:VCALENDAR'].join('\r\n') + '\r\n';
  }

  function issueMailto(orderNo, issue, statusText) {
    var subject = 'Order ' + orderNo + ' — ' + issue;
    var body = 'Order: ' + orderNo + '\nStatus: ' + statusText + '\nDate: ' + new Date().toDateString() +
      '\nPage: ' + ((window.location && window.location.href) || '') + '\n\nWhat happened:\n';
    return 'mailto:' + SUPPORT_EMAIL + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
  }

  // Carrier marks, best first: (1) real multi-color logo hosted as a theme asset (light chip),
  // (2) monochrome simple-icons path (inline fill), (3) DM-mono text badge with the lastMile name.
  // All keys/URLs are static constants — never user data.
  // asset_url values are injected by Liquid as data-* on .okt (this file stays pure JS).
  var ASSET_LOGOS = {
    auspost: (root.dataset.logoAuspost || '').trim(),
    uniuni: (root.dataset.logoUniuni || '').trim(),
    speedx: (root.dataset.logoSpeedx || '').trim(),
    usps: (root.dataset.logoUsps || '').trim()
  };
  var SVG_NS = 'http://www.w3.org/2000/svg';
  var LOGOS = {
    usps: 'M3.145 4.577L0 19.423h20.855L24 4.577H3.145zm-.157 3.806h9.436c.157 0 5.064 0 5.159.975H9.09l1.321 4.026c1.51-.723 5.222-2.233 7.455-2.328.944-.031 1.321.126 1.132.252-.126.063-1.038.189-1.761.377-1.258.315-1.321.315-2.642.755-1.478.503-2.705 1.069-4.53 1.919L.723 18.983l2.265-10.6zm16.483 1.698c-.535-.094-2.768.063-3.334.063-.126 0-.472.031-.472-.063 0-.063.126-.063.377-.094s1.006-.157 1.258-.283c.063-.063.22-.157.315-.252.031-.063.063-.094.157-.094h1.164c.755 0 1.195.094 1.132.723-.031.315-.472 1.132-.629 1.384-.063.094-.189.189-.157 0 .126-.503.597-1.321.189-1.384zm.88 8.902H2.076s17.363-6.794 17.552-6.92c0 0 1.541-2.076.629-2.925-.283-.283-.692-.283-2.265-.283 0 0-.063-.598-2.485-1.164-.283-.063-11.858-2.517-11.858-2.517h19.628l-2.926 13.809zm2.925-.695c0-.195-.114-.293-.358-.293h-.406v1.008h.146v-.439h.179l.276.455h.179L23 18.564c.162-.016.276-.097.276-.276zm-.455.146h-.163v-.341h.211c.114 0 .228.016.228.163 0 .162-.13.178-.276.178zm.016-.829a.868.868 0 0 0-.894.878c0 .504.406.894.894.894s.894-.39.894-.894a.878.878 0 0 0-.894-.878zm0 1.642c-.423 0-.731-.325-.731-.764 0-.423.325-.748.731-.748.406 0 .731.325.731.748 0 .439-.325.764-.731.764z',
    fedex: 'M22.498 14.298c-.016-.414.345-.751.75-.755a.745.745 0 0 1 .752.755.755.755 0 0 1-.751.745c-.395.002-.759-.346-.751-.745zm.759-.083c.067-.02.164-.042.162-.13.007-.09-.086-.133-.162-.134h-.163v.263c0 .001.165-.002.163.001zm-.163.107v.418h-.14v-.91h.327c.156-.021.294.092.286.253a.218.218 0 0 1-.156.19c.162.083.108.322.173.467h-.156a2.355 2.355 0 0 1-.04-.205c-.018-.093-.047-.229-.17-.213h-.124zm.76-.024a.603.603 0 0 0-.605-.632c-.338-.012-.62.302-.605.632a.619.619 0 0 0 .605.622.61.61 0 0 0 .605-.622zm-5.052-.579l-.878 1.008h-1.306l1.559-1.745-1.56-1.75h1.355l.902.997.878-.998h1.306l-1.543 1.743 1.559 1.753h-1.371l-.901-1.008zm-4.703-.352v-.827h1.904v-1.506l1.724 1.948-1.724 1.941v-1.556h-1.904zm1.56 1.36h-3.2V9.044h3.224v1.024H13.77v1.163h1.888v.958h-1.904v1.522h1.904v1.016zm-5.705-.655c-.54.017-.878-.552-.877-1.04-.01-.507.307-1.123.878-1.105.579-.025.871.6.845 1.103.023.501-.29 1.062-.846 1.042zM4.743 12.41c.076-.358.403-.67.78-.663a.788.788 0 0 1 .803.663H4.743zm15.182.564l1.815-2.047h-2.125l-.74.844-.763-.844h-4.037v-.548h1.912V8.741H10.84v2.58c-.362-.448-.981-.559-1.526-.492-.782.123-1.427.762-1.634 1.514-.254-.958-1.179-1.588-2.157-1.554-.781.009-1.6.365-1.987 1.071v-.818h-1.87v-.9h2.043v-1.4H0v6.287h1.666v-2.644h1.666a7.59 7.59 0 0 0-.082.622c-.013 1.232 1.042 2.27 2.274 2.236a2.204 2.204 0 0 0 2.157-1.432H6.254c-.14.268-.441.38-.73.36-.457.009-.83-.417-.829-.86h2.914c.083 1.027.988 1.966 2.043 1.947a1.53 1.53 0 0 0 1.19-.639v.41h7.215l.754-.86.754.86h2.192l-1.832-2.055z',
    ups: 'M11.668 14.544l-.028-5.226c.138-.055.387-.111.608-.111.995 0 1.41.774 1.41 2.682 0 1.853-.47 2.765-1.438 2.765-.22 0-.441-.055-.552-.11zM3.124 7.438c4.203-3.843 9.29-4.866 14.018-4.866 1.3 0 2.544.083 3.76.194h-.028v11.253c0 2.184-.774 3.926-2.295 5.171-1.355 1.134-5.447 2.959-6.581 3.456-1.161-.525-5.253-2.378-6.581-3.456-1.493-1.244-2.295-3.014-2.295-5.171V7.438zm12.664 2.599c.028.912.276 1.576 1.687 2.406.747.442 1.051.747 1.051 1.272 0 .581-.387.94-1.023.94-.553 0-1.189-.304-1.631-.691v1.576c.553.304 1.217.525 1.88.525 1.687 0 2.433-1.189 2.461-2.267.028-.995-.249-1.742-1.659-2.571-.608-.387-1.134-.636-1.106-1.244 0-.581.525-.802.995-.802.581 0 1.161.332 1.521.691V8.378c-.304-.221-.94-.581-1.88-.553-1.135.028-2.296.829-2.296 2.212zm-5.834 9.484h1.714l-.028-3.594c.166.028.415.083.774.083 1.908 0 2.986-1.687 2.986-4.175 0-2.461-1.106-4.009-3.152-4.009-.94 0-1.687.221-2.295.608v11.087zm-5.945-6.166c0 1.797.829 2.71 2.516 2.71 1.051 0 1.908-.249 2.571-.691V7.991H7.41v6.387c-.194.138-.47.221-.802.221-.774 0-.885-.719-.885-1.189V7.991H4.009v5.364zM22.12 2.295v11.723c0 2.516-.94 4.645-2.765 6.111-1.549 1.3-6.332 3.429-7.355 3.871-1.023-.442-5.806-2.571-7.355-3.843-1.797-1.465-2.765-3.594-2.765-6.111V2.295C4.756.747 8.074 0 12 0s7.244.747 10.12 2.295zm-.304.221c-2.71-1.465-6-2.184-9.788-2.184s-7.079.746-9.788 2.184v11.502c0 2.433.912 4.452 2.627 5.862 1.576 1.3 6.581 3.484 7.161 3.76.581-.249 5.585-2.433 7.161-3.733 1.714-1.41 2.627-3.429 2.627-5.862V2.516zm-2.433 20.295c0 .47-.387.829-.829.829a.831.831 0 0 1-.829-.829c0-.47.387-.829.829-.829.441 0 .801.359.829.829zm-.166 0a.679.679 0 0 0-.664-.691c-.359 0-.664.332-.664.691 0 .359.304.664.664.664a.673.673 0 0 0 .664-.664zm-.553.055c.028.055.304.442.304.442h-.221s-.276-.387-.276-.415h-.028v.415h-.194v-.995l.304-.028c.249 0 .332.166.332.304s-.083.25-.221.277zm.027-.276c0-.055 0-.138-.166-.138h-.083v.304h.028c.194 0 .221-.083.221-.166z',
    dhl: 'M4.22 10.303l-.767 1.043h4.18c.21 0 .208.078.105.218-.105.142-.28.39-.386.534-.054.073-.154.207.171.207h1.71l.505-.69c.314-.426.028-1.312-1.095-1.312H4.22zm7.204 0l-1.475 2.002h5.39l1.473-2.002H14.61l-.843 1.146h-.985l.846-1.146h-2.203zm6.105 0l-1.474 2.002h2.334l1.472-2.002H17.53zm-12.845 1.3l-1.54 2.094h3.754c1.24 0 1.932-.844 2.145-1.136h-2.56c-.326 0-.226-.133-.172-.207.107-.143.283-.388.388-.53.104-.14.107-.22-.105-.22h-1.91zM0 12.562v.242h3.398l.176-.242H0zm9.762 0l-.836 1.136h2.203l.836-1.136H9.762zm3.185 0l-.836 1.136h2.203l.836-1.136h-2.203zm2.918 0s-.159.22-.238.326c-.276.374-.033.81.87.81h3.538l.834-1.136h-5.004zm5.408 0l-.177.242H24v-.242h-2.727zM0 13.01v.24h3.068l.178-.24H0zm20.943 0l-.175.24H24v-.24h-3.057zM0 13.457v.24h2.74l.176-.24H0zm20.615 0l-.177.24H24v-.24h-3.385z'
  };
  function carrierMark(carrierKey, lastMile) {
    if (!carrierKey) return null; // old contract: text-only ledger line, no mark
    var key = String(carrierKey).toLowerCase();
    // real logo chip; the double-brace guard skips unrendered Liquid (static previews outside Shopify)
    var asset = ASSET_LOGOS[key];
    if (asset && asset.indexOf('{' + '{') === -1) {
      var chip = document.createElement('span'); chip.className = 'okt-carrier-chip';
      chip.setAttribute('aria-hidden', 'true'); // the adjacent text already names the carrier
      var img = document.createElement('img'); img.src = asset; img.alt = ''; img.loading = 'lazy';
      chip.appendChild(img);
      return chip;
    }
    var path = LOGOS[key];
    if (path) {
      var svg = document.createElementNS(SVG_NS, 'svg');
      svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('width', '16'); svg.setAttribute('height', '16');
      svg.setAttribute('class', 'okt-carrier-logo'); svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
      var p = document.createElementNS(SVG_NS, 'path'); p.setAttribute('d', path);
      svg.appendChild(p);
      return svg;
    }
    var badge = document.createElement('span'); badge.className = 'okt-carrier-badge';
    badge.textContent = lastMile || String(carrierKey);
    return badge;
  }

  // Product rows: 40px thumb + "2× Title — variant". Used by the order strip and per-package blocks.
  function productRows(products) {
    var list = document.createElement('div'); list.className = 'okt-plist';
    products.forEach(function (pr) {
      if (!pr || !(pr.title || pr.image)) return;
      var row = document.createElement('div'); row.className = 'okt-prow';
      if (pr.image) {
        var img = document.createElement('img'); img.className = 'okt-prow-thumb';
        img.src = pr.image; img.alt = pr.title || ''; img.loading = 'lazy';
        row.appendChild(img);
      }
      var lbl = document.createElement('span'); lbl.className = 'okt-prow-label';
      lbl.textContent = (pr.quantity > 1 ? pr.quantity + '\u00d7 ' : '') + (pr.title || '') + (pr.variant ? ' \u2014 ' + pr.variant : '');
      row.appendChild(lbl); list.appendChild(row);
    });
    return list;
  }

  // Build one stage timeline into `stepsEl`. order_placed is prepended from the order date
  // (packages don't carry it themselves — it's shared across a split order). Single-package
  // and per-package timelines go through here so the DOM is identical.
  function renderSteps(stepsEl, pkgStages, currentStage, placedAt, extras) {
    extras = extras || {};
    var stages = (pkgStages || []).slice();
    if (placedAt) stages.unshift({ stage: 'order_placed', timestamp: placedAt });
    var byStage = {}, byStageLabel = {};
    stages.forEach(function (s) {
      if (!(s.stage in byStage)) byStage[s.stage] = s.timestamp;
      if (s.dateLabel && !(s.stage in byStageLabel)) byStageLabel[s.stage] = s.dateLabel;
    });
    var current = currentStage || 'shipment_prepared';
    var currentIdx = ORDER.indexOf(current);
    // pickup awaiting collection: the relabeled "out for delivery" slot IS the collection step and
    // must read as the current lit step whether the parcel reached OFD (DE) or jumped from arrival
    // straight to the locker (AU). Never demote a further-along (delivered/collected) spine.
    var OFD_IDX = ORDER.indexOf('out_for_delivery');
    if (extras.pickupReady && currentIdx > -1 && currentIdx < OFD_IDX) currentIdx = OFD_IDX;
    stepsEl.innerHTML = '';
    stepsEl.setAttribute('role', 'list');
    ORDER.forEach(function (stage, i) {
      var reached = stage in byStage;
      // show every stage up to the furthest reached, plus the immediate next as "upcoming"
      if (i > currentIdx + 1 && !reached) return;
      var state = i === currentIdx ? 'is-current' : (i < currentIdx ? 'is-done' : 'is-upcoming');
      var ts = byStage[stage];
      var lblDate = (byStageLabel && byStageLabel[stage]) || null;
      var when = state === 'is-upcoming' ? (stage === 'delivered' ? t('spine_expected_soon', 'Expected soon') : '') : (lblDate || fmtDate(ts) || '');
      var div = document.createElement('div');
      div.className = 'okt-step ' + state;
      div.setAttribute('role', 'listitem');
      // convey stage state to assistive tech: current via aria-current, others via SR-only text
      if (state === 'is-current') { div.setAttribute('aria-current', 'step'); }
      else { var srState = document.createElement('span'); srState.className = 'okt-sr-only'; srState.textContent = state === 'is-done' ? 'Completed: ' : 'Upcoming: '; div.appendChild(srState); }
      var node = document.createElement('span'); node.className = 'okt-node'; node.setAttribute('aria-hidden', 'true');
      // last-mile carrier surfaces only at the final stages. pickup-ready shipments never go "out for
      // delivery" — relabel that step to the collection state and drop the carrier suffix/mark there.
      var lblText = LABELS[stage];
      var ofdPickup = stage === 'out_for_delivery' && extras.pickupReady;
      if (ofdPickup) lblText = t('status_ready_for_collection', 'Ready for collection');
      else if (stage === 'out_for_delivery' && extras.lastMile) lblText += ' — ' + extras.lastMile;
      var lbl = document.createElement('div'); lbl.className = 'okt-lbl';
      var lblSpan = document.createElement('span'); lblSpan.textContent = lblText; lbl.appendChild(lblSpan);
      // carrier mark (logo or badge) on the final-mile rows; muted, gold on the current row
      if ((stage === 'out_for_delivery' || stage === 'delivered') && state !== 'is-upcoming' && !ofdPickup) {
        var mark = carrierMark(extras.carrierKey, extras.lastMile);
        if (mark) lbl.appendChild(mark);
      }
      var tsEl = document.createElement('div'); tsEl.className = 'okt-ts'; tsEl.textContent = when;
      div.appendChild(node); div.appendChild(lbl); div.appendChild(tsEl);
      // sub-line: delivery-time hint while out for delivery; once delivered, the drop-off
      // place ("Left at: Front door / porch · USPS") beats the generic "Delivered by X"
      var sub = null;
      if (stage === 'out_for_delivery' && extras.deliveryHint) sub = extras.deliveryHint;
      else if (stage === 'delivered' && state !== 'is-upcoming') {
        if (extras.deliveredPlace) sub = t('spine_left_at', 'Left at: ') + extras.deliveredPlace + (extras.lastMile ? ' · ' + extras.lastMile : '');
        else if (extras.lastMile) sub = t('spine_delivered_by', 'Delivered by ') + extras.lastMile;
      }
      if (sub) { var subEl = document.createElement('div'); subEl.className = 'okt-substep'; subEl.textContent = sub; div.appendChild(subEl); }
      stepsEl.appendChild(div);
    });
  }

  // Compact per-package activity feed. Collapsed to the newest 3 rows with a toggle.
  // Synthetic filler rows are styled identically (owner wants them indistinguishable).
  function renderFeed(container, events) {
    if (!events || !events.length) return; // no events yet -> no feed, no empty box
    var rows = events.slice().reverse(); // newest first
    var wrap = document.createElement('div'); wrap.className = 'okt-feed';
    var head = document.createElement('div'); head.className = 'okt-feed-head'; head.textContent = t('feed_activity', 'Activity');
    wrap.appendChild(head);
    // "alive" header: last-scan recency + manual refresh (re-runs the lookup; backend cache makes it cheap)
    var live = document.createElement('div'); live.className = 'okt-feed-live';
    live.setAttribute('data-okt', 'feed-live');
    // "Last carrier scan" must point at a REAL scan, never a synthetic filler row — a just-shipped
    // order with only synthetic rows would otherwise fake a recent, checkable scan time.
    var realTs = null;
    for (var ri = 0; ri < rows.length; ri++) { if (!rows[ri].synthetic && rows[ri].ts) { realTs = rows[ri].ts; break; } }
    var rel = realTs ? relTime(realTs) : null;
    if (rel) {
      var dot = document.createElement('span'); dot.className = 'okt-live-dot'; dot.setAttribute('aria-hidden', 'true');
      var lt = document.createElement('span'); lt.textContent = tf('feed_last_scan', 'Last carrier scan: {rel}', { rel: rel });
      live.appendChild(dot); live.appendChild(lt);
    } else {
      // no real scan yet: be honest instead of timestamping a synthetic filler row
      var awaiting = document.createElement('span');
      awaiting.textContent = t('feed_awaiting', 'Awaiting first carrier scan — usually within 24-48 hours');
      live.appendChild(awaiting);
    }
    var rf = document.createElement('button'); rf.type = 'button'; rf.className = 'okt-feed-refresh';
    rf.textContent = t('refresh_check', 'Check for updates');
    rf.addEventListener('click', function () {
      if (!lastArgs || rf.disabled) return;
      var hadFocus = document.activeElement === rf;
      var idx = Array.prototype.indexOf.call(root.querySelectorAll('.okt-feed-refresh'), rf);
      rf.disabled = true; rf.textContent = t('refresh_checking', 'Checking\u2026');
      lookup(lastArgs.on, lastArgs.em, { silent: true, onDone: function (ok) {
        rf.disabled = false;
        var sr = el('sr-status');
        if (ok === 'same') {
          if (sr) sr.textContent = t('refresh_uptodate_sr', "You're up to date");
          rf.textContent = t('refresh_uptodate', "You're up to date \u2713");
          setTimeout(function () { rf.textContent = t('refresh_check', 'Check for updates'); }, 2500);
        } else if (ok) {
          // render() rebuilt the feed: announce, and hand focus to the NEW button
          if (sr) sr.textContent = t('refresh_updated_sr', 'Tracking updated with new information');
          if (hadFocus) {
            var nbs = root.querySelectorAll('.okt-feed-refresh');
            var nb = nbs[idx] || nbs[0];
            if (nb) { try { nb.focus({ preventScroll: true }); } catch (e) { nb.focus(); } }
          }
        } else {
          rf.textContent = t('refresh_try_again', 'Try again in a minute');
        }
      } });
    });
    live.appendChild(rf);
    wrap.appendChild(live);
    var list = document.createElement('div'); list.className = 'okt-feed-list';
    list.setAttribute('role', 'list');
    var listId = 'okt-feed-' + (window.__oktSeq = (window.__oktSeq || 0) + 1);
    list.id = listId;
    if (rows.length > 3) list.classList.add('is-collapsed');
    rows.forEach(function (e) {
      var row = document.createElement('div'); row.className = 'okt-feed-row'; row.setAttribute('role', 'listitem');
      // real local scan text (destination-country only, provided by the backend) replaces the
      // generic label and reads slightly brighter
      var lbl = document.createElement('span');
      lbl.className = e.detail ? 'okt-feed-label okt-feed-label--detail' : 'okt-feed-label';
      lbl.textContent = e.detail || e.label;
      var when = document.createElement('span'); when.className = 'okt-feed-when';
      // server-side wall-clock labels: the scan's LOCAL time, never re-shifted into the viewer's TZ
      when.textContent = e.dateLabel
        ? (e.timeLabel ? e.dateLabel + ', ' + e.timeLabel : e.dateLabel)
        : (e.showTime ? fmtDateTime(e.ts) : (fmtDate(e.ts) || ''));
      row.appendChild(lbl); row.appendChild(when);
      list.appendChild(row);
    });
    wrap.appendChild(list);
    if (rows.length > 3) {
      var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'okt-feed-toggle';
      btn.setAttribute('aria-expanded', 'false'); btn.setAttribute('aria-controls', listId);
      btn.textContent = tf('feed_show_all', 'Show all updates ({n})', { n: rows.length });
      btn.addEventListener('click', function () {
        var collapsed = list.classList.toggle('is-collapsed');
        btn.setAttribute('aria-expanded', String(!collapsed));
        btn.textContent = collapsed ? tf('feed_show_all', 'Show all updates ({n})', { n: rows.length }) : t('feed_show_fewer', 'Show fewer updates');
      });
      wrap.appendChild(btn);
    }
    container.appendChild(wrap);
  }

  // 5-phase journey map. Absent/malformed `journey` -> hidden, page identical to before.
  function renderJourney(j) {
    var wrap = el('journey');
    if (!wrap) return;
    if (!j || !Array.isArray(j.phases) || !j.phases.length) { wrap.hidden = true; return; }
    wrap.hidden = false;
    var track = el('journey-track');
    track.innerHTML = '';
    var curLbl = '', lastDoneLbl = '';
    j.phases.forEach(function (ph) {
      var st = ph.state === 'done' || ph.state === 'current' ? ph.state : 'upcoming';
      if (st === 'current') curLbl = ph.label || '';
      if (st === 'done') lastDoneLbl = ph.label || lastDoneLbl;
      // final (delivered) phase reached -> filled dot, never a hollow "unreached" ring
      var seg = document.createElement('div');
      seg.className = 'okt-phase is-' + st + (ph.key === 'delivered' ? ' is-final' : '');
      seg.setAttribute('role', 'listitem');
      if (st === 'current') { seg.setAttribute('aria-current', 'step'); }
      else { var sr = document.createElement('span'); sr.className = 'okt-sr-only'; sr.textContent = st === 'done' ? 'Completed: ' : 'Upcoming: '; seg.appendChild(sr); }
      var dot = document.createElement('span'); dot.className = 'okt-phase-dot'; dot.setAttribute('aria-hidden', 'true');
      var lbl = document.createElement('div'); lbl.className = 'okt-phase-lbl'; lbl.textContent = ph.label || '';
      seg.appendChild(dot); seg.appendChild(lbl); track.appendChild(seg);
    });
    // <=480px shows dots only + this single centered label (per-dot labels collide at 390px)
    var cur = el('journey-current');
    if (cur) cur.textContent = curLbl || lastDoneLbl;
    // day-counter band. delivered -> real transit time ("Delivered in N days", tastefully qualified
    // against the typical window); beyond-typical & undelivered -> stay silent (the monitor band owns
    // that honesty); otherwise the running "Day N — typically X-Y" as before.
    var day = el('journey-day');
    var typ = j.typicalDays || '';
    var mt = /(\d+)\s*-\s*(\d+)/.exec(typ), tMin = mt ? +mt[1] : null, tMax = mt ? +mt[2] : null;
    var dayText = '';
    if (j.deliveredInDays) {
      dayText = tf('journey_delivered_in', 'Delivered in {n} days', { n: j.deliveredInDays });
      if (tMin != null && j.deliveredInDays < tMin) dayText += t('journey_faster', ' — faster than typical');
      else if (tMax != null && j.deliveredInDays <= tMax) dayText += t('journey_on_pace', ' — right on pace');
      dayText += '.';
    } else if (!j.beyondTypical && j.dayOfJourney && typ) {
      dayText = tf('journey_day', 'Day {n} — typically {typ} days door to door.', { n: j.dayOfJourney, typ: typ });
    }
    day.textContent = dayText;
    day.hidden = !day.textContent;
  }

  // ── route map — port of the approved prototype (route.js): equirectangular 900x396, arc from
  // 55° west of the destination, quadratic lift, dash-draw + comet. Adaptations: the world map is
  // a cached <img> theme asset; the prototype's per-dot tinting became a radial-gradient glow
  // behind the pin; labels are textContent-only; reduced motion renders the full arc statically.
  var mapRaf = 0;
  function svgNode(name, attrs) {
    var e = document.createElementNS(SVG_NS, name);
    for (var k in attrs) e.setAttribute(k, attrs[k]);
    return e;
  }
  function renderMap(dest, progressPct, current) {
    var wrap = el('map');
    if (!wrap) return;
    if (mapRaf) { cancelAnimationFrame(mapRaf); mapRaf = 0; } // kill any prior comet before we may bail out
    var ok = dest && isFinite(dest.lat) && isFinite(dest.lon);
    if (!ok || (window.innerWidth || 1024) < 560) { wrap.hidden = true; return; }
    wrap.hidden = false;
    var stage = el('map-stage');
    var img = stage.querySelector('.okt-map-img');
    stage.querySelectorAll('.okt-map-overlay, .okt-map-label').forEach(function (n) { n.remove(); });
    if (img && img.parentNode !== stage) stage.appendChild(img); // zoom removal takes the img with it
    var W = 900, H = 396, GOLD = '#c8956c';
    var p = Math.min(1, Math.max(0, (Number(progressPct) || 0) / 100));
    var lat = Number(dest.lat), lon = Number(dest.lon);
    var dx = (lon + 180) / 360 * W, dy = (90 - lat) / 180 * H;
    // no modulo on the origin longitude: keeps the short path across the antimeridian (approved)
    var sx = (lon - 55 + 180) / 360 * W, sy = dy;
    var qx = (sx + dx) / 2, qy = Math.min(sy, dy) - 0.18 * H;
    var arcD = 'M' + sx.toFixed(1) + ' ' + sy.toFixed(1) + ' Q' + qx.toFixed(1) + ' ' + qy.toFixed(1) + ' ' + dx.toFixed(1) + ' ' + dy.toFixed(1);
    var uid = 'oktm' + (window.__oktSeq = (window.__oktSeq || 0) + 1);
    var svg = svgNode('svg', { viewBox: '0 0 ' + W + ' ' + H, preserveAspectRatio: 'none', 'class': 'okt-map-overlay', 'aria-hidden': 'true', focusable: 'false' });
    var defs = svgNode('defs', {});
    var filt = svgNode('filter', { id: uid + 'b', x: '-40%', y: '-40%', width: '180%', height: '180%' });
    filt.appendChild(svgNode('feGaussianBlur', { stdDeviation: '2.4' }));
    var grad = svgNode('radialGradient', { id: uid + 'g' });
    grad.appendChild(svgNode('stop', { offset: '0', 'stop-color': GOLD, 'stop-opacity': '0.45' }));
    grad.appendChild(svgNode('stop', { offset: '1', 'stop-color': GOLD, 'stop-opacity': '0' }));
    defs.appendChild(filt); defs.appendChild(grad);
    svg.appendChild(defs);
    // soft warm glow behind the pin (replaces the prototype's per-dot tinting)
    svg.appendChild(svgNode('circle', { cx: dx, cy: dy, r: 30, fill: 'url(#' + uid + 'g)' }));
    // The route deliberately has no origin point (origin is masked) — so the line must not
    // start abruptly: a userSpaceOnUse gradient fades it in from transparent at the start
    // to full gold at the destination, as if emerging from the network.
    // (id must differ from the radial pin glow above — duplicate SVG ids resolve first-wins)
    var arcGrad = svgNode('linearGradient', { id: uid + 'a', gradientUnits: 'userSpaceOnUse', x1: sx, y1: sy, x2: dx, y2: dy });
    arcGrad.appendChild(svgNode('stop', { offset: '0', 'stop-color': GOLD, 'stop-opacity': '0' }));
    arcGrad.appendChild(svgNode('stop', { offset: '0.45', 'stop-color': GOLD, 'stop-opacity': '0.55' }));
    arcGrad.appendChild(svgNode('stop', { offset: '1', 'stop-color': GOLD, 'stop-opacity': '1' }));
    defs.appendChild(arcGrad);
    // faint full-route guide UNDERNEATH: the bright trail only draws up to the comet, so without
    // this the route reads as two unrelated marks — the guide carries the eye on to the pin.
    var guide = svgNode('path', { d: arcD, fill: 'none', stroke: GOLD, 'stroke-opacity': '0.8', 'stroke-width': '1.3', 'stroke-dasharray': '2.5 3.5' });
    svg.appendChild(guide);
    var glowP = svgNode('path', { d: arcD, fill: 'none', stroke: 'url(#' + uid + 'a)', 'stroke-width': '3.2', 'stroke-linecap': 'round', opacity: '0.35', filter: 'url(#' + uid + 'b)' });
    var arc = svgNode('path', { d: arcD, fill: 'none', stroke: 'url(#' + uid + 'a)', 'stroke-width': '1.5', 'stroke-linecap': 'round' });
    svg.appendChild(glowP); svg.appendChild(arc);
    svg.appendChild(svgNode('circle', { 'class': 'okt-map-ring', cx: dx, cy: dy, r: 5, fill: 'none', stroke: GOLD, 'stroke-width': '1.2' }));
    svg.appendChild(svgNode('circle', { cx: dx, cy: dy, r: 3.4, fill: GOLD }));
    svg.appendChild(svgNode('circle', { cx: dx, cy: dy, r: 1.3, fill: '#0a0a0a' }));
    var dot = svgNode('circle', { r: 3, fill: GOLD, filter: 'url(#' + uid + 'b)', opacity: '0' });
    var dot2 = svgNode('circle', { r: 1.9, fill: '#F5DFC9', opacity: '0' });
    svg.appendChild(dot); svg.appendChild(dot2);
    stage.appendChild(svg);
    var pinFx = dx / W, pinFy = dy / H;
    // destination label — textContent only, edge-aware anchoring (approved logic)
    var lab = document.createElement('div'); lab.className = 'okt-map-label';
    // map label stays short: first two comma-segments, trailing postcode stripped — US zip/zip+4,
    // CA "A1A 1A1", UK "SW1A 1AA" (deliverTo elsewhere keeps the full postcode).
    var shortLabel = String(dest.label || '').split(',').slice(0, 2).join(',')
      .replace(/\s+([A-Za-z]{1,2}\d[A-Za-z\d]?\s?\d[A-Za-z]{2}|[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d|\d{4,}(?:-\d+)?)\b/g, '')
      .replace(/,\s*$/, '').trim(); // stateless city (postcode-only 2nd segment stripped) -> drop the dangling comma
    var labTxt = document.createElement('span'); labTxt.textContent = shortLabel;
    var pctEl = document.createElement('span'); pctEl.className = 'okt-map-pct';
    pctEl.textContent = p >= 1 ? t('map_delivered', 'DELIVERED') : tf('map_pct', '{n}% of route', { n: Math.round(p * 100) });
    lab.appendChild(labTxt); lab.appendChild(pctEl);
    lab.style.left = (pinFx * 100) + '%';
    lab.style.top = (pinFy * 100) + '%';
    var nearRight = pinFx > 0.72, tx, ty;
    if (nearRight) { tx = 'calc(-100% + 12px)'; ty = pinFy > 0.7 ? 'calc(-100% - 16px)' : '18px'; }
    else { tx = '14px'; ty = pinFy < 0.12 ? '14px' : '-50%'; }
    lab.style.transform = 'translate(' + tx + ', ' + ty + ')';
    stage.appendChild(lab);
    var sum = el('map-summary');
    if (sum) sum.textContent = (current === 'delivered' ? t('map_delivered_to', 'Delivered to ') : t('map_on_its_way', 'On its way to ')) + (dest.label || 'your address');
    // reduced motion (or no matchMedia): static arc truncated at the real progress, no comet
    var still = !window.matchMedia || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!arc.getTotalLength) return;
    var len = arc.getTotalLength();
    arc.style.strokeDasharray = len; glowP.style.strokeDasharray = len;
    if (still) {
      var offStill = len * (1 - p);
      arc.style.strokeDashoffset = offStill; glowP.style.strokeDashoffset = offStill;
      return;
    }
    var frame = function (drawn) {
      var off = len * (1 - drawn);
      arc.style.strokeDashoffset = off; glowP.style.strokeDashoffset = off;
      var pt = arc.getPointAtLength(len * drawn);
      dot.setAttribute('cx', pt.x); dot.setAttribute('cy', pt.y);
      dot2.setAttribute('cx', pt.x); dot2.setAttribute('cy', pt.y);
      var vis = drawn > 0.001 && drawn < 0.999;
      dot.style.opacity = vis ? 0.5 : 0; dot2.style.opacity = vis ? 1 : 0;
    };
    if (p === 0) { frame(0); return; }
    var t0 = performance.now();
    var tick = function (now) {
      var k = Math.min(1, Math.max(0, (now - t0) / 1500));
      frame(p * (1 - Math.pow(1 - k, 3)));
      if (k < 1) mapRaf = requestAnimationFrame(tick);
    };
    mapRaf = requestAnimationFrame(tick);
  }

  var lastDataJson = null; // change-detection for silent refresh
  function render(data, opts) {
    var pkgs = data.packages || [];
    var multi = pkgs.length > 1;
    var placedAt = (data.order && data.order.placedAt) || null;
    // clear any activity feed from a previous lookup (single-path feed lives outside pkgWrap)
    root.querySelectorAll('.okt-feed').forEach(function (n) { n.remove(); });
    // single real order carries its richness on packages[0]; demo mode carries it top-level.
    var primary = (data.packages && data.packages[0]) || data;

    // headline + ledger read the legacy top-level fields, which the backend mirrors to the
    // LEAST-advanced package — so a split order never reads "delivered" while one still moves.
    var current = data.currentStage || 'shipment_prepared';
    // pickup awaiting collection: ONE flag drives headline, status-label, the spine's collection
    // step and the suppressed ETA — so the OFD-path (DE) and arrived-direct (AU) pickups converge
    // on "Ready for collection" everywhere. dInfo mirrors the pickup card's source below.
    var dInfo = data.deliveredInfo || primary.deliveredInfo || null;
    var pickupReady = !!(dInfo && dInfo.pickup && !collectedOf(dInfo, current));
    var head = { out_for_delivery: t('head_out_for_delivery', 'Out for delivery.'), delivered: t('head_delivered', 'Delivered.'), in_transit: t('head_in_transit', 'On its way.'),
                 arrived_destination_country: t('head_arrived_destination_country', 'Almost there.'), shipment_prepared: t('head_shipment_prepared', 'Getting it ready.'), order_placed: t('head_order_placed', 'Order received.') };
    el('headline').textContent = pickupReady ? t('head_ready_for_collection', 'Ready for collection.') : (head[current] || t('head_default', 'On its way.'));
    // one-time gentle gold glow on delivery (CSS keeps it motion-preference-gated)
    el('headline').className = current === 'delivered' ? 'okt-status okt-glow' : 'okt-status';

    var etaText = etaValue(data.estimatedDelivery);
    // story block: countdown (etaRange) leads as a Playfair-gold em; phaseNote follows with the
    // ETA folded in. Without the new fields the lede renders exactly as before.
    var phaseNote = data.phaseNote || primary.phaseNote || null;
    var etaRange = data.etaRange || primary.etaRange || null;
    var cd = pickupReady ? null : countdownText(etaRange, current, data.ofdStale);
    var line = el('eta-line');
    var lead = multi ? tf('ships_in', 'Your order ships in {n} packages.', { n: pkgs.length }) : '';
    var part = function (t) { var s = document.createElement('span'); s.textContent = t; line.appendChild(s); };
    var leadEm = function (t) { var e2 = document.createElement('em'); e2.textContent = t; line.appendChild(e2); part(' '); };
    if (phaseNote) {
      line.textContent = '';
      if (lead) part(lead + ' ');
      if (cd) leadEm(cd + '.');
      else if (!pickupReady && current === 'out_for_delivery' && !data.ofdStale) leadEm(t('cd_today_dot', 'Arriving today.'));
      // pickup-ready: the parcel is already at the locker — no ETA tail, the phaseNote carries it
      part(phaseNote + (!pickupReady && etaText ? tf('eta_estimated_tail', ' Estimated delivery {v}.', { v: etaText }) : ''));
    } else if (cd) {
      line.textContent = '';
      leadEm(cd + '.');
      part(multi ? lead : etaSentence(current, etaText, false));
    } else {
      line.textContent = multi ? lead : etaSentence(current, etaText, false);
    }
    // add-to-calendar: etaRange present, machine-parseable, not delivered
    var calOk = !!(etaRange && /^\d{4}-\d{2}-\d{2}$/.test(String(etaRange.from)) &&
      /^\d{4}-\d{2}-\d{2}$/.test(String(etaRange.to)) && current !== 'delivered');
    calState = calOk ? { order: (data.order && data.order.number) || '', from: String(etaRange.from), to: String(etaRange.to) } : null;
    if (el('cal')) el('cal').hidden = !calOk;
    // "what happens next" sub-line (gold Next: prefix; strip a leading "Next:" from the data)
    var nextStep = data.nextStep || primary.nextStep || null;
    var ns = el('next-step');
    ns.textContent = '';
    ns.hidden = !nextStep;
    if (nextStep) {
      var k = document.createElement('span'); k.className = 'okt-next-k'; k.textContent = t('next_prefix', 'Next:');
      var rest = document.createElement('span'); rest.textContent = ' ' + String(nextStep).replace(/^next:?,?\s*/i, '');
      ns.appendChild(k); ns.appendChild(rest);
    }
    // journey map + route map + monitor band (new contract fields; absent -> hidden).
    // ONE route map from the top-level mirror, even for split orders.
    var journeyData = data.journey || primary.journey || null;
    renderJourney(journeyData);
    renderMap(data.destination || primary.destination || null, journeyData && journeyData.progressPct, current);
    var monitorNote = data.monitorNote || primary.monitorNote || null;
    el('monitor-note').textContent = monitorNote || '';
    el('monitor').hidden = !monitorNote;

    // delivered orders: the ledger cell reads "Delivered / <date>" instead of a stale/empty estimate.
    var deliveredLabel = data.deliveredDateLabel || primary.deliveredDateLabel || null;
    var estK = el('estimated-k');
    if (current === 'delivered' && deliveredLabel) {
      el('estimated').textContent = deliveredLabel;
      if (estK) estK.textContent = 'Delivered';
    } else {
      // pickup-ready: the ETA is provably wrong (it's at the locker), so show the live state, not a
      // stale date. "Ready now" over "Ready for collection" to avoid mirroring the Status cell below.
      el('estimated').textContent = pickupReady ? t('estimated_ready_now', 'Ready now')
        : (etaText || (current === 'out_for_delivery' && !data.ofdStale ? t('estimated_today', 'Today') : '—'));
      if (estK) estK.textContent = 'Estimated';
    }
    el('status-label').textContent = pickupReady ? t('status_ready_for_collection', 'Ready for collection') : (LABELS[current] || '—');
    // last-mile is known from day one (destination country) — show it in the ledger,
    // not only at the out-for-delivery stage
    var lastMile = (pkgs[0] && pkgs[0].lastMile) || null;
    var carrierKey = primary.carrierKey || data.carrierKey || null;
    el('carrier-label').textContent = data.carrierLabel || 'Okura Logistics';
    // honest default: scans name no carrier brand, so promise a local courier, not a guess
    el('lastmile').textContent = '';
    var lmSpan = document.createElement('span');
    lmSpan.textContent = t('lastmile_prefix', 'Final delivery by ') + (lastMile || t('lastmile_courier', 'local courier'));
    el('lastmile').appendChild(lmSpan);
    var lm = carrierMark(carrierKey, lastMile);
    if (lm) el('lastmile').appendChild(lm);
    el('lastmile').hidden = false;
    el('order-number').textContent = (data.order && data.order.number) ? ('#' + String(data.order.number).replace(/^#/, '')) : '—';

    // "Delivering to" ledger row (new contract; absent -> hidden)
    var deliverTo = data.deliverTo || primary.deliverTo || null;
    el('deliverto').textContent = deliverTo || '';
    el('deliverto-cell').hidden = !deliverTo;

    // pickup/collection card (deliveredInfo.pickup); home delivery place renders on the
    // delivered spine row instead (extras.deliveredPlace below)
    var showPickup = !!(dInfo && dInfo.pickup && dInfo.place);
    // past-tense "Collected from" only on the backend's explicit collected flag; older
    // responses without the flag fall back to the stage heuristic (works with both contracts)
    var collected = showPickup && collectedOf(dInfo, current);
    el('pickup').hidden = !showPickup;
    if (showPickup) {
      el('pickup-title').textContent = (collected ? t('pickup_collected', 'Collected from ') : t('pickup_ready', 'Ready for collection — ')) + dInfo.place;
      el('pickup-note').textContent = collected ? '' : (dInfo.note || '');
      el('pickup-note').hidden = collected || !dInfo.note;
      el('pickup-addr').textContent = deliverTo || ''; el('pickup-addr').hidden = !deliverTo;
      el('pickup').classList.toggle('is-collected', collected);
    }

    // order-level "In this order" strip (order.products = all items across packages).
    // When present it replaces the single-product hero panel — strictly more informative.
    var orderProducts = (data.order && data.order.products) || null;
    var strip = el('order-products');
    var stripList = el('order-products-list');
    stripList.innerHTML = '';
    if (orderProducts && orderProducts.length) {
      stripList.appendChild(productRows(orderProducts));
      strip.hidden = false;
    } else strip.hidden = true;

    // order-level product panel: shown for a single shipment; hidden when split, since each
    // package prints its own product title below.
    var p = data.order && data.order.product;
    var pwrap = el('product');
    if (!multi && !(orderProducts && orderProducts.length) && p && (p.title || p.image)) {
      pwrap.hidden = false;
      if (p.image) { el('product-image').src = p.image; el('product-image').alt = p.title || ''; }
      el('product-title').textContent = p.title || '';
      el('product-variant').textContent = p.variant || '';
    } else { pwrap.hidden = true; }

    // timeline(s): single shipment keeps the .okt-track block; a split order hides it and
    // renders one labelled .okt-pkg block per package instead.
    var track = root.querySelector('.okt-track');
    var pkgWrap = el('packages');
    pkgWrap.innerHTML = '';
    if (multi) {
      track.hidden = true;
      pkgWrap.hidden = false;
      pkgs.forEach(function (pkg) {
        var block = document.createElement('div'); block.className = 'okt-pkg';
        var h = document.createElement('h2'); h.className = 'okt-pkg-head';
        h.textContent = tf('pkg_head', 'Package {index} of {count}', { index: pkg.index, count: pkg.count });
        block.appendChild(h);
        // which products travel in THIS package: full list when the backend sends it,
        // else the old single-title line (old contract unchanged)
        if (pkg.products && pkg.products.length) {
          block.appendChild(productRows(pkg.products));
        } else if (pkg.product && pkg.product.title) {
          var t = document.createElement('div'); t.className = 'okt-pkg-title';
          t.textContent = pkg.product.title; block.appendChild(t);
        }
        var steps = document.createElement('div'); steps.className = 'okt-steps';
        renderSteps(steps, pkg.stages, pkg.currentStage, placedAt, {
          lastMile: pkg.lastMile, deliveryHint: pkg.deliveryHint, carrierKey: pkg.carrierKey,
          deliveredPlace: (pkg.deliveredInfo && !pkg.deliveredInfo.pickup && pkg.deliveredInfo.place) || null,
          pickupReady: !!(pkg.deliveredInfo && pkg.deliveredInfo.pickup && !collectedOf(pkg.deliveredInfo, pkg.currentStage))
        });
        block.appendChild(steps);
        var etaLine = document.createElement('p'); etaLine.className = 'okt-pkg-eta';
        etaLine.textContent = etaSentence(pkg.currentStage, etaValue(pkg.estimatedDelivery), true);
        block.appendChild(etaLine);
        renderFeed(block, pkg.events);
        pkgWrap.appendChild(block);
      });
    } else {
      track.hidden = false;
      pkgWrap.hidden = true;
      renderSteps(el('steps'), data.stages, data.currentStage, placedAt, {
        lastMile: primary.lastMile, deliveryHint: primary.deliveryHint, carrierKey: carrierKey,
        deliveredPlace: (dInfo && !dInfo.pickup && dInfo.place) || null,
        pickupReady: pickupReady
      });
      renderFeed(track, primary.events);
    }

    // issue escalation + post-delivery care + contextual FAQ
    var delivered = current === 'delivered';
    var showIssues = delivered || !!data.hasException;
    el('issues').hidden = !showIssues;
    if (showIssues) {
      var ordNo = (data.order && data.order.number) || '';
      var statusText = LABELS[current] || String(current);
      [['issue-damaged', 'Damaged'], ['issue-missing', 'Missing item'], ['issue-never', 'Never arrived']]
        .forEach(function (pair) { var a = el(pair[0]); if (a) a.href = issueMailto(ordNo, pair[1], statusText); });
    }
    // care copy implies the customer HAS the pan — never show it while the pickup card above
    // still reads "Ready for collection" (awaiting-collection pickup)
    el('care').hidden = !delivered || (showPickup && !collected);
    el('care-link').hidden = !CARE_URL;
    // FAQ order: delivered floats the "something wrong" item (pointing at the buttons above);
    // in transit/monitoring the quiet-pause item already leads by default.
    var faqWrap = root.querySelector('.okt-faq');
    var fqW = el('faq-wrong'), fqP = el('faq-pause'), fqH = el('faq-home'), fqO = el('faq-origin');
    if (faqWrap && fqW && fqP && fqH && fqO) {
      fqW.hidden = !delivered;
      (delivered ? [fqW, fqP, fqH, fqO] : [fqP, fqH, fqO, fqW])
        .forEach(function (d) { faqWrap.appendChild(d); }); // appendChild moves -> idempotent reorder
    }

    root.querySelector('.okt-demo-pill').hidden = !data._demo;
    lastDataJson = JSON.stringify(data);
    view('result', opts);
  }

  // ── DEMO resolver (used when no backend endpoint is configured) ──
  function demoResolve(orderNumber, email) {
    var n = String(orderNumber).replace(/[^0-9a-z]/gi, '').toLowerCase();
    if (n !== '1001') return { found: false };
    return {
      found: true, _demo: true,
      order: { number: '1001', placedAt: '2026-06-01T09:12:00Z',
        product: { title: 'Hand-Hammered Titanium Pan', variant: '28 cm',
          image: 'https://okuracookware.com/cdn/shop/files/openart-gpt-image-2-edit-1_1779527831233_d311e337.png' },
        products: [
          { title: 'Hand-Hammered Titanium Pan', variant: '28 cm', quantity: 2,
            image: 'https://okuracookware.com/cdn/shop/files/openart-gpt-image-2-edit-1_1779527831233_d311e337.png' },
          { title: 'Titanium Pan Lid', variant: '28 cm', quantity: 1, image: '' }
        ] },
      carrierLabel: 'Okura Logistics', currentStage: 'out_for_delivery', hasException: false,
      estimatedDelivery: '2026-06-19',
      lastMile: 'USPS', deliveryHint: 'Usually delivered before 9:00 PM local time',
      carrierKey: 'usps',
      deliverTo: '94-1044 Konohiki St, Mililani, HI 96789',
      deliveredInfo: { place: 'USPS Pickup Point — Mililani Town Center', pickup: true,
        note: 'Bring a photo ID. Your package is held for 7 days.' },
      destination: { lat: 21.45, lon: -158.0, label: 'Mililani, HI' },
      etaRange: (function () { // relative window so the demo countdown/ICS always exercise live paths
        var t = new Date(), pad = function (n) { return (n < 10 ? '0' : '') + n; };
        var f = function (d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); };
        return { from: f(new Date(t.getFullYear(), t.getMonth(), t.getDate() + 2)),
                 to: f(new Date(t.getFullYear(), t.getMonth(), t.getDate() + 6)) };
      })(),
      journey: {
        phases: [
          { key: 'prepared', label: 'Prepared', state: 'done' },
          { key: 'international', label: 'International transit', state: 'done' },
          { key: 'in_country', label: 'In the United States', state: 'done' },
          { key: 'out_for_delivery', label: 'Out for delivery', state: 'current' },
          { key: 'delivered', label: 'Delivered', state: 'upcoming' }
        ],
        progressPct: 88, dayOfJourney: 9, typicalDays: '8-16'
      },
      phaseNote: 'Your package is on a local USPS delivery vehicle in your area.',
      nextStep: "The delivery scan will appear here the moment it's dropped off.",
      monitorNote: "It's been quiet for a few days — parcels often sit at a sorting hub between scans, then move again on their own. This page updates the moment it does.",
      quietDays: 0,
      stages: [
        { stage: 'shipment_prepared', timestamp: '2026-06-01T10:00:00Z' },
        { stage: 'in_transit', timestamp: '2026-06-08T11:00:00Z' },
        { stage: 'arrived_destination_country', timestamp: '2026-06-08T20:00:00Z' },
        { stage: 'out_for_delivery', timestamp: '2026-06-09T07:00:00Z' }
      ],
      events: [
        { label: 'Shipping information received', ts: '2026-06-01T10:00:00Z', showTime: false, synthetic: false },
        { label: 'Departed international sorting facility', ts: '2026-06-03T02:10:00Z', showTime: false, synthetic: false },
        { label: 'Moving through the international logistics network', ts: '2026-06-05T12:00:00Z', showTime: false, synthetic: true },
        { label: 'Cleared for onward transport', ts: '2026-06-08T09:30:00Z', showTime: false, synthetic: false },
        { label: 'Arrival scan at transit facility', ts: '2026-06-08T20:00:00Z', showTime: false, synthetic: false, detail: 'Mililani, HI 96789, Arrived at USPS Facility' },
        { label: 'Out for delivery with your local carrier', ts: '2026-06-09T07:00:00Z', showTime: true, synthetic: false, detail: 'Mililani, HI 96789, Out for Delivery' }
      ]
    };
  }

  // Rate-limited is NOT "not found": tell an anxious refresher to breathe, never that
  // their order doesn't exist (that reaction is exactly the WISMO->chargeback path).
  function setEmptyCopy(rateLimited) {
    var h = root.querySelector('[data-okt="empty-headline"]');
    var l = root.querySelector('[data-okt="empty-lede"]');
    if (!h || !l) return;
    if (rateLimited) {
      h.textContent = t('empty_rl_head', 'Just a moment.');
      l.textContent = t('empty_rl_lede', "You're checking faster than the carriers update. Give it a minute, then try again.");
    } else {
      h.textContent = t('empty_head', "We couldn't find that order.");
      l.textContent = t('empty_lede', 'Double-check the order number and email. If it was placed in the last hour it may not be ready yet.');
    }
  }

  // Show the not-found/rate-limited state. Blank the result headline first: an error must not
  // leave a stale hidden status claim ("On its way.") in the DOM — automated checks read it and
  // screen readers can reach it.
  function showEmpty(rateLimited) {
    var hd = el('headline'); if (hd) hd.textContent = '';
    setEmptyCopy(rateLimited);
    view('empty');
  }

  function lookup(orderNumber, email, opts) {
    opts = opts || {};
    lastArgs = { on: orderNumber, em: email };
    if (!opts.silent) view('loading');
    var done = function (data) {
      if (data && data.found) {
        if (opts.silent) {
          var fresh = JSON.stringify(data);
          if (fresh === lastDataJson) { if (opts.onDone) opts.onDone('same'); return; } // nothing new: touch NOTHING
          root.classList.add('okt-no-anim'); // in-place update: no stagger replay, no focus jump
          render(data, { noFocus: true });
          requestAnimationFrame(function(){ requestAnimationFrame(function(){ root.classList.remove('okt-no-anim'); }); });
        } else { render(data); }
        if (opts.onDone) opts.onDone(true); return;
      }
      if (opts.silent) { if (opts.onDone) opts.onDone(false); return; } // quiet refresh never nukes the view
      showEmpty(data && data.rateLimited);
    };
    if (!ENDPOINT) { setTimeout(function () { done(demoResolve(orderNumber, email)); }, 650); return; }
    var headers = { 'Content-Type': 'application/json' };
    if (ANON) { headers['Authorization'] = 'Bearer ' + ANON; headers['apikey'] = ANON; }
    // A valid order can intermittently miss on first load (network/edge blip). Retry ONCE after
    // ~1.5s on a thrown fetch or a non-ok status that isn't a definitive answer. A 200 found:false
    // and a 429 rate-limit are definitive — surfaced immediately, no retry. Silent refreshes
    // never retry (they already degrade to a no-op without nuking the view).
    var request = function () {
      return fetch(ENDPOINT, {
        method: 'POST', headers: headers,
        body: JSON.stringify({ orderNumber: orderNumber, email: email, shop: window.location.hostname })
      }).then(function (r) {
        if (r.status === 429) return { found: false, rateLimited: true };
        if (r.ok) return r.json();
        return { __blip: true }; // non-ok edge blip: retryable, not a definitive found:false
      });
    };
    var attempt = function (retriesLeft) {
      request().then(function (data) {
        if (data && data.__blip) {
          if (retriesLeft > 0) { setTimeout(function () { attempt(retriesLeft - 1); }, 1500); return; }
          done({ found: false }); return;
        }
        done(data);
      }).catch(function () {
        if (retriesLeft > 0) { setTimeout(function () { attempt(retriesLeft - 1); }, 1500); return; }
        // a network blip during a silent refresh must never nuke a populated result view
        if (opts.silent) { if (opts.onDone) opts.onDone(false); return; }
        showEmpty(false);
      });
    };
    attempt(opts.silent ? 0 : 1);
  }

  // add-to-calendar: one listener, state swapped per render (never stacks listeners)
  var calState = null;
  (function () {
    var btn = el('cal');
    if (!btn) return;
    btn.addEventListener('click', function () {
      if (!calState || typeof Blob === 'undefined') return;
      var ics = buildIcs(calState.order, calState.from, calState.to, (window.location && window.location.href) || '');
      var blob = new Blob([ics], { type: 'text/calendar' });
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url; a.download = 'okura-delivery.ics';
      a.click();
      setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
    });
  })();

  var form = root.querySelector('.okt-form');
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var on = form.orderNumber.value.trim(), em = form.email.value.trim();
    var err = form.querySelector('.okt-form-error');
    var emailBad = !em || em.indexOf('@') < 0;
    form.orderNumber.setAttribute('aria-invalid', on ? 'false' : 'true');
    form.email.setAttribute('aria-invalid', emailBad ? 'true' : 'false');
    if (!on || emailBad) {
      err.textContent = t('form_error', 'Please enter a valid order number and email.'); err.hidden = false;
      (on ? form.email : form.orderNumber).focus();
      return;
    }
    err.hidden = true;
    lookup(on, em);
  });
  root.querySelectorAll('.okt-back').forEach(function (b) { b.addEventListener('click', function () { view('form'); }); });

  // auto-load from URL: ?order=1001&email=...
  try {
    var q = new URLSearchParams(window.location.search);
    if (q.get('order')) {
      form.orderNumber.value = q.get('order');
      if (q.get('email')) form.email.value = q.get('email');
      if (q.get('email')) lookup(q.get('order'), q.get('email'));
    }
  } catch (e) {}
})();
